/* --- Dawn fence: prevent native cart listeners from handling bundle footer --- */
/* bundle-cart v2: spinner + cache-bust refresh + rAF delay */
(function fenceDawnForBundleFooter() {
    document.addEventListener('click', function (e) {
        const footer = e.target.closest('.fw-bundle-footer-row');
        if (!footer) return;
        const isQtyBtn = e.target.closest('.fw-qty-inc, .fw-qty-dec');
        const isRemove = e.target.closest('.fw-bundle-remove');
        if (!(isQtyBtn || isRemove)) return;
        e.preventDefault();
        e.stopPropagation();
        /* do not stopImmediatePropagation so our bundle handler (same target) still runs */
    }, true);

    document.addEventListener('change', function (e) {
        const input = e.target.closest('.fw-bundle-footer-row input.fw-qty-input');
        if (!input) return;
        e.stopPropagation();
        /* do not stopImmediatePropagation so our bundle handler still runs */
    }, true);
})();

/* -----------------------------------------------------------
   Custom Club Builder: Shaft + Grip, add bundle to cart
   Re-runs when product-info is replaced (e.g. variant/URL change).
   ----------------------------------------------------------- */
(function () {
    const log = (...a) => console.log("🔹 %cCustom Club", "background:#e0e8ff;color:#2a52c9;font-weight:bold;padding:2px;", ...a);
    const warn = (...a) => console.warn("🔹 %cCustom Club", "background:#e0e8ff;color:#2a52c9;font-weight:bold;padding:2px;", ...a);
    const err = (...a) => console.error("🔹 %cCustom Club", "background:#e0e8ff;color:#2a52c9;font-weight:bold;padding:2px;", ...a);

    function initCustomClubBuilder() {
        const root = document.getElementById('fresh-custom-club-builder');
        if (!root) return;
        if (root.dataset.fwInitialized === 'true') return;

    let data = { bundleTitle: 'Custom Club', shaftsByVariant: {}, gripsByVariant: {} };
    try {
        const el = document.getElementById('fresh-custom-club-data');
        if (el) data = JSON.parse(el.textContent || '{}');
    } catch (e) {
        err('Failed to parse builder data', e);
        return;
    }

    const shaftsByVariant = data.shaftsByVariant && typeof data.shaftsByVariant === 'object' ? data.shaftsByVariant : {};
    const gripsByVariant = data.gripsByVariant && typeof data.gripsByVariant === 'object' ? data.gripsByVariant : {};
    const baseProductVariants = (data.baseProduct && data.baseProduct.variants) ? data.baseProduct.variants : [];
    const bundleTitle = data.bundleTitle || root.dataset.bundleTitle || 'Custom Club';
    /* Current base variant: from Liquid (initial) and variantChange event (when customer changes option) */
    var currentBaseVariantId = data.selectedVariantId != null ? String(data.selectedVariantId) : null;
    var currentBaseVariantPrice = data.selectedVariantPrice != null ? Number(data.selectedVariantPrice) : null;

    const money = (c) => (window.Shopify && Shopify.formatMoney)
        ? Shopify.formatMoney(c)
        : '$' + (c / 100).toFixed(2);

    const $ = (sel) => root.querySelector(sel);
    const $shaft = $('[data-component="shaft"]');
    const $grip = $('[data-component="grip"]');
    const $previewShaft = $('[data-preview="shaft"]');
    const $previewGrip = $('[data-preview="grip"]');
    const $total = $('[data-total]');
    const $add = $('[data-add]');
    const $note = $('[data-note]');

    function getCurrentShafts() {
        return (currentBaseVariantId && shaftsByVariant[currentBaseVariantId]) ? shaftsByVariant[currentBaseVariantId] : [];
    }
    function getCurrentGrips() {
        return (currentBaseVariantId && gripsByVariant[currentBaseVariantId]) ? gripsByVariant[currentBaseVariantId] : [];
    }

    function byTitle(a, b) {
        return (a.product_title || '').localeCompare(b.product_title || '') ||
            (a.variant_title || '').localeCompare(b.variant_title || '');
    }

    function renderOptions(select, pool, placeholder) {
        if (!select) return;
        const opts = ['<option value="">' + (placeholder || 'Select') + '</option>'].concat(
            pool.sort(byTitle).map(function (v) {
                const text = v.product_title || v.variant_title || 'Variant ' + v.variant_id;
                return '<option value="' + v.variant_id + '" data-price="' + (v.price || 0) + '" data-img="' + (v.image || '') + '">' + text + '</option>';
            })
        );
        select.innerHTML = opts.join('');
    }

    function setPreview(el, variantId, pool) {
        if (!el) return;
        const v = pool.find(function (x) { return String(x.variant_id) === String(variantId); });
        el.innerHTML = v && v.image ? '<img src="' + v.image + '" alt="">' : '';
    }

    function updateTotal() {
        const shaftId = $shaft && $shaft.value ? $shaft.value : null;
        const gripId = $grip && $grip.value ? $grip.value : null;
        const shafts = getCurrentShafts();
        const grips = getCurrentGrips();
        let sum = 0;
        if (currentBaseVariantId) {
            if (currentBaseVariantPrice != null) sum += currentBaseVariantPrice;
            else if (baseProductVariants.length) {
                const baseV = baseProductVariants.find(function (x) { return String(x.variant_id) === String(currentBaseVariantId); });
                if (baseV) sum += baseV.price || 0;
            }
        }
        if (shaftId) {
            const v = shafts.find(function (x) { return String(x.variant_id) === String(shaftId); });
            if (v) sum += v.price || 0;
        }
        if (gripId) {
            const v = grips.find(function (x) { return String(x.variant_id) === String(gripId); });
            if (v) sum += v.price || 0;
        }
        if ($total) $total.textContent = sum > 0 ? 'Total: ' + money(sum) : '—';
        if ($add) $add.disabled = !(shaftId && gripId);
    }

    /* ---------- Next "Custom Club N" ---------- */
    function extractNum(str) {
        if (!str) return null;
        const m = String(str).match(/custom[-\s]?club[-\s]?(\d+)/i);
        return m ? parseInt(m[1], 10) : null;
    }

    function fetchCart() {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
    }

    function maxBundleNumFromCart(cart) {
        const nums = (cart.items || [])
            .map(function (li) {
                const bid = li.properties && (li.properties['Bundle ID'] || li.properties['bundle_id']);
                return bid ? extractNum(bid) : null;
            })
            .filter(function (n) { return Number.isInteger(n); });
        return nums.length ? Math.max.apply(null, nums) : 0;
    }

    function maxBundleNumFromAttribute(cart) {
        try {
            const raw = cart.attributes && cart.attributes.bundles;
            const arr = raw ? JSON.parse(raw) : [];
            const nums = arr
                .map(function (b) { return b && (b.id || b['Bundle ID']); })
                .map(extractNum)
                .filter(function (n) { return Number.isInteger(n); });
            return nums.length ? Math.max.apply(null, nums) : 0;
        } catch (_) {
            return 0;
        }
    }

    var nextBundleNum = null;
    function getNextBundleId(force) {
        if (nextBundleNum !== null && !force) return 'Custom Club ' + nextBundleNum;
        return fetchCart().then(function (cart) {
            var max = Math.max(maxBundleNumFromCart(cart), maxBundleNumFromAttribute(cart));
            if (window.freshCustomClubCount && Number.isInteger(window.freshCustomClubCount)) {
                max = Math.max(max, window.freshCustomClubCount);
            }
            nextBundleNum = max + 1;
            return 'Custom Club ' + nextBundleNum;
        }).catch(function () {
            nextBundleNum = 1;
            return 'Custom Club 1';
        });
    }

    function upsertBundleAttribute(bundleId, variantIds) {
        return fetchCart().then(function (cart) {
            var current = [];
            try {
                if (cart.attributes && cart.attributes.bundles) {
                    current = JSON.parse(cart.attributes.bundles);
                }
            } catch (_) {}
            current = current.filter(function (b) {
                var id = b && (b.id || b['Bundle ID']);
                return id !== bundleId;
            });
            current.push({
                id: bundleId,
                name: bundleTitle,
                created_at: new Date().toISOString(),
                lines: variantIds.map(function (vId, idx) {
                    return { choice: idx + 1, variant_id: String(vId) };
                })
            });
            return fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ attributes: { bundles: JSON.stringify(current) } })
            });
        });
    }

    function removeBundleFromAttribute(bundleId) {
        return fetchCart().then(function (cart) {
            var current = [];
            try {
                if (cart.attributes && cart.attributes.bundles) {
                    current = JSON.parse(cart.attributes.bundles);
                }
            } catch (_) {}
            var next = current.filter(function (b) {
                var id = b && (b.id || b['Bundle ID']);
                return id !== bundleId;
            });
            return fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ attributes: { bundles: JSON.stringify(next) } })
            });
        }).catch(function () {});
    }

    function addBundle() {
        var shaftId = $shaft && $shaft.value ? $shaft.value : null;
        var gripId = $grip && $grip.value ? $grip.value : null;
        if (!shaftId || !gripId) return;

        var includeBaseProduct = !!currentBaseVariantId;

        var btnText = (root.dataset.buttonText || 'Add to Cart');
        $add.disabled = true;
        $add.textContent = 'Adding…';
        if ($note) $note.textContent = '';

        getNextBundleId(true).then(function (bundleId) {
            var items = [];
            if (includeBaseProduct) {
                items.push({
                    id: parseInt(currentBaseVariantId, 10),
                    quantity: 1,
                    properties: {
                        'Bundle': bundleTitle,
                        'Bundle ID': bundleId,
                        'Component': 'Club'
                    }
                });
            }
            items.push(
                {
                    id: parseInt(shaftId, 10),
                    quantity: 1,
                    properties: {
                        'Bundle': bundleTitle,
                        'Bundle ID': bundleId,
                        'Component': 'Shaft'
                    }
                },
                {
                    id: parseInt(gripId, 10),
                    quantity: 1,
                    properties: {
                        'Bundle': bundleTitle,
                        'Bundle ID': bundleId,
                        'Component': 'Grip'
                    }
                }
            );
            var variantIdsForAttribute = includeBaseProduct ? [currentBaseVariantId, shaftId, gripId] : [shaftId, gripId];
            return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ items: items })
            }).then(function (res) {
                if (!res.ok) throw new Error('Add failed');
                return res.json();
            }).then(function () {
                return upsertBundleAttribute(bundleId, variantIdsForAttribute);
            }).then(function () {
                if (window.freshCustomClubCount == null) window.freshCustomClubCount = 0;
                window.freshCustomClubCount = Math.max(window.freshCustomClubCount, nextBundleNum);
                nextBundleNum = null;
                return fwRefreshCartUI(true);
            }).then(function () {
                $add.textContent = 'Added!';
            }).catch(function (e) {
                err('Add bundle failed', e);
                if ($note) $note.textContent = 'Could not add bundle. Please try again.';
                $add.textContent = btnText;
                $add.disabled = false;
            });
        });
    }

    /* Populate selects from current base variant */
    renderOptions($shaft, getCurrentShafts(), 'Select shaft');
    renderOptions($grip, getCurrentGrips(), 'Select grip');
    updateTotal();

    if ($shaft) {
        $shaft.addEventListener('change', function () {
            setPreview($previewShaft, $shaft.value, getCurrentShafts());
            updateTotal();
        });
    }
    if ($grip) {
        $grip.addEventListener('change', function () {
            setPreview($previewGrip, $grip.value, getCurrentGrips());
            updateTotal();
        });
    }
    if ($add) $add.addEventListener('click', addBundle);

    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
        var sectionId = root.closest('product-info') ? root.closest('product-info').getAttribute('data-section') : null;
        subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
            if (!root.isConnected || !event || !event.data) return;
            if (event.data.sectionId !== sectionId) return;
            var v = event.data.variant;
            if (v && v.id != null) {
                currentBaseVariantId = String(v.id);
                currentBaseVariantPrice = (v.price != null) ? Number(v.price) : null;
                if (currentBaseVariantPrice == null && baseProductVariants.length) {
                    var bv = baseProductVariants.find(function (x) { return String(x.variant_id) === currentBaseVariantId; });
                    if (bv) currentBaseVariantPrice = bv.price || null;
                }
                renderOptions($shaft, getCurrentShafts(), 'Select shaft');
                renderOptions($grip, getCurrentGrips(), 'Select grip');
                setPreview($previewShaft, $shaft && $shaft.value ? $shaft.value : null, getCurrentShafts());
                setPreview($previewGrip, $grip && $grip.value ? $grip.value : null, getCurrentGrips());
                updateTotal();
            }
        });
    }

        root.dataset.fwInitialized = 'true';

    window.__freshCustomClubBuilder = {
        getNextBundleId: getNextBundleId,
        upsertBundleAttribute: upsertBundleAttribute,
        removeBundleFromAttribute: removeBundleFromAttribute
    };
    }

    function runWhenReady(fn) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', fn);
        } else {
            fn();
        }
    }
    runWhenReady(initCustomClubBuilder);
    document.addEventListener('product-info:loaded', initCustomClubBuilder);

    /* Watch for builder added later (e.g. section re-render, async load) */
    var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
            var added = mutations[i].addedNodes;
            for (var j = 0; j < added.length; j++) {
                var node = added[j];
                if (node.nodeType !== 1) continue;
                if (node.id === 'fresh-custom-club-builder' || node.querySelector && node.querySelector('#fresh-custom-club-builder')) {
                    setTimeout(initCustomClubBuilder, 0);
                    return;
                }
            }
        }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    /* Run once on next tick in case DOM is ready when script runs */
    setTimeout(initCustomClubBuilder, 0);
    window.initCustomClubBuilder = initCustomClubBuilder;
})();

/* -----------------------------------------------------------
   Cart: Bundle footer controls (qty + remove)
   ----------------------------------------------------------- */
(function () {
    var cssEsc = function (s) {
        return (window.CSS && CSS.escape) ? CSS.escape(s) : String(s).replace(/"/g, '\\"');
    };
    var $all = function (sel, root) {
        root = root || document;
        return Array.prototype.slice.call(root.querySelectorAll(sel));
    };
    var pendingUpdates = {};
    var lastUpdateTime = {};
    var DEBOUNCE_MS = 300;

    function findInput(bundleId) {
        return document.querySelector('.fw-bundle-footer-row[data-bundle-id="' + cssEsc(bundleId) + '"] .fw-qty-input');
    }

    function getBundleChildRows(bundleId) {
        return $all('.fw-bundle-child[data-bundle-id="' + cssEsc(bundleId) + '"]');
    }

    function clamp(n) {
        return Math.max(1, parseInt(n, 10) || 1);
    }

    function disableBundleControls(bundleId, disabled) {
        var footer = document.querySelector('.fw-bundle-footer-row[data-bundle-id="' + cssEsc(bundleId) + '"]');
        if (!footer) return;
        footer.querySelectorAll('.fw-qty-inc, .fw-qty-dec').forEach(function (btn) {
            btn.disabled = disabled;
            btn.style.opacity = disabled ? '0.5' : '';
        });
        var input = footer.querySelector('.fw-qty-input');
        if (input) input.disabled = disabled;
        if (disabled) footer.classList.add('fw-loading'); else footer.classList.remove('fw-loading');
    }

    function getCartUpdateUrl() {
        return (typeof window.routes !== 'undefined' && window.routes.cart_update_url)
            ? window.routes.cart_update_url
            : '/cart/update';
    }

    function getFetchConfig() {
        return (typeof fetchConfig === 'function')
            ? fetchConfig()
            : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
    }

    function applySectionsFromParsedState(parsedState) {
        if (!parsedState || typeof parsedState !== 'object' || !parsedState.sections) return;
        var sections = parsedState.sections;

        if (sections['cart-drawer']) {
            var targetDrawer = document.getElementById('CartDrawer');
            if (targetDrawer) {
                var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
                var newInner = doc.querySelector('cart-drawer .drawer__inner') || doc.querySelector('.drawer__inner');
                var newCartDrawerDiv = doc.querySelector('cart-drawer #CartDrawer') || doc.querySelector('#CartDrawer') || doc.querySelector('cart-drawer');
                if (newInner) {
                    var currentInner = targetDrawer.querySelector('.drawer__inner');
                    if (currentInner) currentInner.innerHTML = newInner.innerHTML;
                    else targetDrawer.innerHTML = (newCartDrawerDiv && newCartDrawerDiv.innerHTML) || newInner.innerHTML;
                } else if (newCartDrawerDiv) {
                    targetDrawer.innerHTML = newCartDrawerDiv.innerHTML;
                }
            }
        }

        if (sections['cart-icon-bubble']) {
            var bubbleEl = document.getElementById('cart-icon-bubble');
            if (bubbleEl) {
                var bubbleDoc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
                var newBubble = bubbleDoc.querySelector('.shopify-section');
                if (newBubble) bubbleEl.innerHTML = newBubble.innerHTML;
            }
        }

        var cartDrawerEl = document.querySelector('cart-drawer');
        if (cartDrawerEl && typeof parsedState.item_count === 'number') {
            cartDrawerEl.classList.toggle('is-empty', parsedState.item_count === 0);
            cartDrawerEl.setAttribute('data-cart-item-count', String(parsedState.item_count));
            if (typeof parsedState.total_price === 'number') cartDrawerEl.setAttribute('data-cart-total-price', String(parsedState.total_price));
            var cartDrawerItems = cartDrawerEl.querySelector('cart-drawer-items');
            if (cartDrawerItems) cartDrawerItems.classList.toggle('is-empty', parsedState.item_count === 0);
        }
    }

    function setBundleQuantity(bundleId, qty) {
        var rows = getBundleChildRows(bundleId);
        if (!rows.length) return Promise.resolve();

        var updates = {};
        var seen = {};
        rows.forEach(function (row) {
            var key = row.getAttribute('data-line-key');
            if (key && !seen[key]) {
                seen[key] = true;
                updates[key] = qty;
            }
        });
        if (Object.keys(updates).length === 0) return Promise.resolve();

        var body = JSON.stringify({
            updates: updates,
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname
        });

        return fetch(getCartUpdateUrl(), Object.assign({}, getFetchConfig(), { body: body })).then(function (res) { return res.text(); }).then(function (text) {
            var parsedState = JSON.parse(text);
            if (parsedState.errors) throw new Error(parsedState.description || 'Cart update failed');
            applySectionsFromParsedState(parsedState);
            return parsedState;
        }).then(function () {
            var input = findInput(bundleId);
            var first = document.querySelector('.fw-bundle-child[data-bundle-id="' + cssEsc(bundleId) + '"]');
            if (input && first) input.value = first.getAttribute('data-qty') || String(qty);
        }).catch(function (e) {
            console.error('setBundleQuantity failed', e);
            disableBundleControls(bundleId, false);
            location.reload();
        });
    }

    function removeBundle(bundleId) {
        var rows = getBundleChildRows(bundleId);
        if (!rows.length) return Promise.resolve();

        var updates = {};
        rows.forEach(function (row) {
            var key = row.getAttribute('data-line-key');
            if (key) updates[key] = 0;
        });
        if (Object.keys(updates).length === 0) return Promise.resolve();

        if (window.__freshCustomClubBuilder && window.__freshCustomClubBuilder.removeBundleFromAttribute) {
            window.__freshCustomClubBuilder.removeBundleFromAttribute(bundleId);
        }
        if (window.freshCustomClubCount) window.freshCustomClubCount = null;

        var body = JSON.stringify({
            updates: updates,
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname
        });

        return fetch(getCartUpdateUrl(), Object.assign({}, getFetchConfig(), { body: body })).then(function (res) { return res.text(); }).then(function (text) {
            var parsedState = JSON.parse(text);
            if (parsedState.errors) throw new Error(parsedState.description || 'Cart update failed');
            applySectionsFromParsedState(parsedState);
        }).catch(function () {
            location.reload();
        });
    }

    var MIN_SPINNER_MS = 400;
    var SECTIONS_FIRST_DELAY_MS = 250;
    var SECTIONS_RETRY_DELAY_MS = 200;
    var SECTIONS_MAX_RETRIES = 3;

    function getCartStateFromSectionHtml(html) {
        if (!html || typeof html !== 'string') return null;
        try {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var cartDrawer = doc.querySelector('cart-drawer');
            if (!cartDrawer) return null;
            var count = cartDrawer.getAttribute('data-cart-item-count');
            var total = cartDrawer.getAttribute('data-cart-total-price');
            return {
                item_count: count != null ? parseInt(count, 10) : null,
                total_price: total != null ? parseInt(total, 10) : null
            };
        } catch (e) {
            return null;
        }
    }

    function applySectionsToDOM(json) {
        if (!json || typeof json !== 'object') return;
        var sectionDrawer = document.getElementById('shopify-section-cart-drawer');
        if (sectionDrawer && json['cart-drawer']) {
            sectionDrawer.innerHTML = json['cart-drawer'];
        } else if (json['cart-drawer']) {
            var currentDrawer = document.querySelector('cart-drawer');
            if (currentDrawer) {
                var wrap = document.createElement('div');
                wrap.innerHTML = json['cart-drawer'];
                var newDrawer = wrap.querySelector('cart-drawer');
                if (newDrawer) currentDrawer.innerHTML = newDrawer.innerHTML;
            }
        }
        var bubbleEl = document.getElementById('shopify-section-cart-icon-bubble');
        if (bubbleEl && json['cart-icon-bubble']) bubbleEl.innerHTML = json['cart-icon-bubble'];
    }

    function sectionsMatchExpected(json, expected) {
        if (!expected || json['cart-drawer'] == null) return true;
        var state = getCartStateFromSectionHtml(json['cart-drawer']);
        if (!state || state.item_count == null) return false;
        var countMatch = state.item_count === expected.item_count;
        var totalMatch = expected.total_price == null ||
            state.total_price == null ||
            Number.isNaN(state.total_price) ||
            state.total_price === expected.total_price;
        return countMatch && totalMatch;
    }

    function fetchSections() {
        var sections = ['cart-drawer', 'cart-icon-bubble'];
        var url = window.location.pathname + '?sections=' + sections.join(',') + '&_=' + Date.now();
        return fetch(url, { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
            .then(function (r) { if (!r.ok) throw new Error('Sections fetch ' + r.status); return r.json(); });
    }

    function refreshCartSections(expectedCart) {
        function getExpected() {
            if (expectedCart != null && typeof expectedCart === 'object' && typeof expectedCart.item_count === 'number') {
                return Promise.resolve(expectedCart);
            }
            return fetch(window.Shopify && Shopify.routes && Shopify.routes.cart_url ? Shopify.routes.cart_url + '.js' : '/cart.js', { credentials: 'same-origin' })
                .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('Cart fetch failed')); })
                .then(function (cart) { return { item_count: cart.item_count, total_price: cart.total_price }; });
        }

        function tryOnce(expected, attemptIndex) {
            return fetchSections().then(function (json) {
                if (!json || typeof json !== 'object') throw new Error('Invalid sections response');
                if (sectionsMatchExpected(json, expected)) {
                    applySectionsToDOM(json);
                    return true;
                }
                if (attemptIndex >= SECTIONS_MAX_RETRIES) {
                    location.reload();
                    return true;
                }
                return false;
            });
        }

        function delay(ms) {
            return new Promise(function (resolve) { setTimeout(resolve, ms); });
        }

        return getExpected()
            .then(function (expected) {
                function attempt(n) {
                    return tryOnce(expected, n).then(function (done) {
                        if (done) return;
                        return delay(SECTIONS_RETRY_DELAY_MS).then(function () { return attempt(n + 1); });
                    });
                }
                return delay(SECTIONS_FIRST_DELAY_MS).then(function () { return attempt(0); });
            })
            .catch(function (err) {
                console.warn('Custom Club: sections refresh failed', err);
                location.reload();
            });
    }

    document.addEventListener('click', function (e) {
        var inc = e.target.closest('.fw-qty-inc');
        var dec = e.target.closest('.fw-qty-dec');
        var rm = e.target.closest('.fw-bundle-remove');

        if (inc) {
            e.preventDefault();
            e.stopPropagation();
            var id = inc.getAttribute('data-bundle-id');
            var input = findInput(id);
            if (!input || inc.disabled || pendingUpdates[id]) return;
            var now = Date.now();
            if (now - (lastUpdateTime[id] || 0) < DEBOUNCE_MS) return;
            var current = parseInt(input.value || '1', 10) || 1;
            var next = clamp(current + 1);
            disableBundleControls(id, true);
            input.value = next;
            lastUpdateTime[id] = now;
            pendingUpdates[id] = true;
            requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                    setTimeout(function () {
                        setBundleQuantity(id, next).finally(function () {
                            delete pendingUpdates[id];
                            disableBundleControls(id, false);
                        });
                    }, MIN_SPINNER_MS);
                });
            });
        }
        if (dec) {
            e.preventDefault();
            e.stopPropagation();
            var id = dec.getAttribute('data-bundle-id');
            var input = findInput(id);
            if (!input || dec.disabled || pendingUpdates[id]) return;
            var now = Date.now();
            if (now - (lastUpdateTime[id] || 0) < DEBOUNCE_MS) return;
            var current = parseInt(input.value || '1', 10) || 1;
            var next = clamp(current - 1);
            disableBundleControls(id, true);
            input.value = next;
            lastUpdateTime[id] = now;
            pendingUpdates[id] = true;
            requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                    setTimeout(function () {
                        setBundleQuantity(id, next).finally(function () {
                            delete pendingUpdates[id];
                            disableBundleControls(id, false);
                        });
                    }, MIN_SPINNER_MS);
                });
            });
        }
        if (rm) {
            e.preventDefault();
            e.stopPropagation();
            var row = rm.closest && rm.closest('.fw-bundle-footer-row');
            var bundleId = (rm.getAttribute('data-bundle-id') || (row && row.getAttribute('data-bundle-id')) || '').trim();
            if (bundleId) {
                row && row.classList.add('fw-loading');
                requestAnimationFrame(function () {
                    requestAnimationFrame(function () {
                        setTimeout(function () {
                            removeBundle(bundleId).finally(function () {
                                var f = document.querySelector('.fw-bundle-footer-row[data-bundle-id="' + cssEsc(bundleId) + '"]');
                                if (f) f.classList.remove('fw-loading');
                            });
                        }, MIN_SPINNER_MS);
                    });
                });
            }
        }
    }, true);

    document.addEventListener('change', function (e) {
        var input = e.target.closest('.fw-bundle-footer-row .fw-qty-input');
        if (!input || input.disabled) return;
        var id = input.getAttribute('data-bundle-id');
        if (pendingUpdates[id]) return;
        var now = Date.now();
        if (now - (lastUpdateTime[id] || 0) < DEBOUNCE_MS) return;
        var next = clamp(input.value);
        disableBundleControls(id, true);
        input.value = next;
        lastUpdateTime[id] = now;
        pendingUpdates[id] = true;
        requestAnimationFrame(function () {
            requestAnimationFrame(function () {
                setTimeout(function () {
                    setBundleQuantity(id, next).finally(function () {
                        delete pendingUpdates[id];
                        disableBundleControls(id, false);
                    });
                }, MIN_SPINNER_MS);
            });
        });
    }, true);

    window.__fwCustomClubCart = { setBundleQuantity: setBundleQuantity, removeBundle: removeBundle, refreshCartSections: refreshCartSections, applySectionsFromParsedState: applySectionsFromParsedState };
})();

/* ---------- Global cart refresh (used after add bundle) ---------- */
function fwRefreshCartUI(openDrawer) {
    var sections = ['cart-drawer', 'cart-icon-bubble'];
    return fetch('/?sections=' + sections.join(',') + '&_=' + Date.now(), { credentials: 'same-origin' })
        .then(function (res) { return res.ok ? res.json() : Promise.reject(new Error('Sections fetch failed')); })
        .then(function (htmlBySection) {
            /* Update cart icon bubble */
            var bubbleSection = document.getElementById('shopify-section-cart-icon-bubble');
            if (bubbleSection && htmlBySection['cart-icon-bubble']) {
                bubbleSection.innerHTML = htmlBySection['cart-icon-bubble'];
            }

            /* Update cart drawer inner content only — preserve the <cart-drawer> element */
            var drawerEl = document.querySelector('cart-drawer');
            if (drawerEl && htmlBySection['cart-drawer']) {
                var doc = new DOMParser().parseFromString(htmlBySection['cart-drawer'], 'text/html');
                var newInner = doc.querySelector('.drawer__inner');
                var currentInner = drawerEl.querySelector('.drawer__inner');
                if (newInner && currentInner) {
                    currentInner.innerHTML = newInner.innerHTML;
                }
                /* Sync empty state + counts */
                var newDrawer = doc.querySelector('cart-drawer');
                if (newDrawer) {
                    var count = newDrawer.getAttribute('data-cart-item-count');
                    var total = newDrawer.getAttribute('data-cart-total-price');
                    if (count != null) drawerEl.setAttribute('data-cart-item-count', count);
                    if (total != null) drawerEl.setAttribute('data-cart-total-price', total);
                    drawerEl.classList.toggle('is-empty', count === '0');
                    var items = drawerEl.querySelector('cart-drawer-items');
                    if (items) items.classList.toggle('is-empty', count === '0');
                }
            }

            document.body.dispatchEvent(new CustomEvent('cart:refresh'));
            if (openDrawer && drawerEl && drawerEl.open) {
                drawerEl.open();
            }
        })
        .catch(function (err) { console.error('fwRefreshCartUI failed', err); });
}

/* ---------- Non-bundle line: qty buttons ---------- */
document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[name="plus"], button[name="minus"]');
    if (!btn || btn.closest('.fw-bundle-footer-row')) return;
    var row = btn.closest('.cart-item');
    if (!row || row.getAttribute('data-bundle-id')) return;
    var key = row.getAttribute('data-line-key');
    if (!key) return;
    var qtyInput = row.querySelector('input[type="number"]');
    if (!qtyInput) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    var current = parseInt(qtyInput.value || '1', 10) || 1;
    var isPlus = btn.getAttribute('name') === 'plus';
    var next = isPlus ? current + 1 : Math.max(1, current - 1);
    fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: next })
    }).then(function (res) {
        if (!res.ok) throw new Error('Change failed');
        return window.__fwCustomClubCart && window.__fwCustomClubCart.refreshCartSections();
    }).catch(function () { location.reload(); });
}, true);

/* ---------- Non-bundle line: remove ---------- */
document.addEventListener('click', function (e) {
    var btn = e.target.closest('.fw-remove-non-bundle');
    if (!btn) return;
    var row = btn.closest('.cart-item');
    var key = row ? row.getAttribute('data-line-key') : null;
    if (!row || !key || row.getAttribute('data-bundle-id')) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    var body = JSON.stringify({
        id: key,
        quantity: 0,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
    });
    fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: body
    })
        .then(function (res) { return res.text(); })
        .then(function (text) {
            var parsedState = JSON.parse(text);
            if (parsedState.errors) throw new Error(parsedState.description || 'Remove failed');
            if (window.__fwCustomClubCart && window.__fwCustomClubCart.applySectionsFromParsedState) {
                window.__fwCustomClubCart.applySectionsFromParsedState(parsedState);
            }
        })
        .catch(function (err) { console.error('Non-bundle remove failed', err); });
}, true);

/* ---------- Page-load: ensure cart drawer reflects bundle grouping ---------- */
(function () {
    function checkBundleGrouping() {
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
                var hasBundleItems = (cart.items || []).some(function (li) {
                    return li.properties && (li.properties['Bundle ID'] || li.properties['bundle_id']);
                });
                if (!hasBundleItems) return;
                var drawer = document.querySelector('cart-drawer');
                if (!drawer) return;
                var hasGroupedRows = drawer.querySelector('.fw-bundle-header-row');
                if (hasGroupedRows) return;
                if (typeof fwRefreshCartUI === 'function') fwRefreshCartUI(false);
            })
            .catch(function () {});
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', checkBundleGrouping);
    } else {
        checkBundleGrouping();
    }
})();